export const facilityCompany = (customer) => {
if(customer?.facility) return false
return true
 
}
export const facilityClient = (client, user) => {
    //console.log("IN CONSOLE FACILITYCLIENT:", client, user)
    const userCustomerId = user?.customer?._ref
    const isContractor = client?.contractors?.some?.((x)=>x?._ref == userCustomerId)
    if(isContractor) return true
    //if(user?.userType == "Tecnico" && client?.facility) return true
    if(client?.facility) return false

    //if(client?.facility) return false

    return true
   }
export const clientUser = (user) => {
    if(user?.userType == "Cliente") return false

return true
   }
export const technician = (user) => {
    if(user?.userType == "Tecnico") return false

return true
   }

export const isGodMode = (user) => {
    if(user?.userType == "God Mode") return true

return false
   }

export const isAdmin = (user) => {
    if(user?.userType == "Admin") return true

        return false
   }

   export const isSuperAdmin = (user) => {
    if(user?.userType == "Super Admin") return true

        return false
   }